import './index.less'

export default {
  
  props:['data'],
  render(){
    const data = this.$utils.conv(this.data || {} , {"createDatetime":'datetime'})

    return <div class="route-view-stats">
      <div class="hd">
        <div class="item">
          <span>{data.total}</span>
          <em>订单总量</em>
        </div>
        <div class="item">
          <span>{data.complete}</span>
          <em>已完成</em>
        </div>
        <div class="item">
          <span>{data.total ? (data.total - data.complete) : null}</span>
          <em>未完成</em>
        </div>
      </div>
      <div class="bd">
        <sl-detail-list label-width="80px" col={1} label-align="right" style="padding:12px;">
          <sl-detail-list-item title="路径单号" content={data.pathNo} />
          <sl-detail-list-item title="派送网点" content={data.companyName} />
          <sl-detail-list-item title="派件人" content={data.courierName} />
          <sl-detail-list-item title="联系电话" content={data.courierPhone} />
          <sl-detail-list-item title="生成日期" content={data.createDatetimeText} />
        </sl-detail-list>
      </div>
    </div>
  }
}